import dynamic, { DynamicOptions } from "next/dynamic";
import { SectionsKey } from "~/constants/enum";
import { getTheme } from "./theme";
import Hero from "~/sections/Hero";
import PromotionBanner from "~/sections/PromotionBanner";
import Brand from "~/sections/Brand";
import ProductMatching from "~/sections/ProductMatching";
import RecentlyView from "~/sections/RecentlyView";
import TopCategory from "~/sections/TopCategory";
import BestSeller from "~/sections/BestSeller";
import MostPopular from "~/sections/MostPopular";
import FeatureProduct from "~/sections/FeaturedProducts";
import NewCollections from "~/sections/NewCollection";
import Trending from "~/sections/Trending";
import Testimonial from "~/sections/Testimonial";
import Recommended from "~/sections/Recommended";
import NotFound from "~/sections/NotFound";
import SimilarProduct from "~/sections/SimilarProduct";
import OrderDetail from "~/sections/OrderDetail";
import ProductDetailTwo from "~/sections/ProductDetailTwo";
import Related from "~/sections/Related";
import ProductTags from "~/sections/ProductTags";
import ProductList from "~/sections/ProductList";
import CollectionsContent from "~/sections/CollectionsContent";
import TabReviews from "~/sections/TabReviews";
import ThankYou from "~/sections/ThankYou";
import OfferProducts from "~/sections/OfferProducts";
import Cart from "~/sections/Cart";
import HomePageReviews from "~/sections/HomePageReviews/HomePageReviews";
import TabReviewsV2 from "~/sections/TabReviewsV2";
import BenefitsSection from "~/sections/BenefitsSection";
import FollowUs from "~/sections/FollowUs";
import Checkout from "~/sections/Checkout";
import SignUp from "~/sections/SignUp";
import BundleBanner from "~/sections/BundleBanner";
import BundleContent from "~/sections/BundleContent";

export const getPageStruct = (themeName = getTheme(), fileName = "") => {
  if (!fileName) return null;
  try {
    const PageStruct = require(
      `~/theme/${themeName}/structure/${fileName}.struct`,
    );
    return PageStruct.default;
  } catch (error) {
    const PageStruct = require(`~/theme/base/structure/${fileName}.struct`);
    return PageStruct.default;
  }
};

const componentMap: any = {
  [SectionsKey.Hero]: Hero,
  [SectionsKey.PromotionBanner]: PromotionBanner,
  [SectionsKey.Brand]: Brand,
  [SectionsKey.ProductMatching]: ProductMatching,
  [SectionsKey.RecentlyView]: RecentlyView,
  [SectionsKey.TopCategory]: TopCategory,
  [SectionsKey.BestSeller]: BestSeller,
  [SectionsKey.MostPopular]: MostPopular,
  [SectionsKey.FeatureProduct]: FeatureProduct,
  [SectionsKey.NewCollections]: NewCollections,
  [SectionsKey.Trending]: Trending,
  [SectionsKey.Testimonial]: Testimonial,
  [SectionsKey.Recommended]: Recommended,
  [SectionsKey.NotFound]: NotFound,
  [SectionsKey.SimilarProduct]: SimilarProduct,
  [SectionsKey.OrderDetail]: OrderDetail,
  [SectionsKey.ProductDetailTwo]: ProductDetailTwo,
  [SectionsKey.Related]: Related,
  [SectionsKey.ProductTags]: ProductTags,
  [SectionsKey.ProductList]: ProductList,
  [SectionsKey.CollectionsContent]: CollectionsContent,
  [SectionsKey.TabReviews]: TabReviews,
  [SectionsKey.TabReviewsV2]: TabReviewsV2,
  [SectionsKey.ThankYou]: ThankYou,
  [SectionsKey.OfferProducts]: OfferProducts,
  [SectionsKey.Cart]: Cart,
  [SectionsKey.HomePageReviews]: HomePageReviews,
  [SectionsKey.BenefitsSection]: BenefitsSection,
  [SectionsKey.FollowUs]: FollowUs,
  [SectionsKey.Checkout]: Checkout,
  [SectionsKey.SignUp]: SignUp,
  [SectionsKey.BundleBanner]: BundleBanner,
  [SectionsKey.BundleContent]: BundleContent,
};

export const renderSectionNew = (item: any, options?: DynamicOptions) => {
  switch (item.id) {
    //struct: product-detail-two
    case SectionsKey.ProductDetailTwo:
      const ComponentToRender = componentMap[item.id];
      if (ComponentToRender) {
        return ComponentToRender;
      } else
        return dynamic(
          () =>
            import(`~/theme/${getTheme()}/sections/ProductDetailTwo`)
              .then((mod) => mod)
              .catch((error) => {
                return import(`~/sections/ProductDetailTwo`).then((mod) => mod);
              }),
          {
            ...options,
          },
        );
    case SectionsKey.Related:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/Related`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/Related`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.ProductList:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/ProductList`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/ProductList`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.ProductTags:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/ProductTags`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/ProductTags`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.Cart:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/Cart`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/Cart`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.NotFound:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/NotFound`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/NotFound`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.CollectionsContent:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/CollectionsContent`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/CollectionsContent`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.TabReviews:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/TabReviews`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/TabReviews`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.TabReviewsV2:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/TabReviewsV2`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/TabReviewsV2`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.HomePageReviews:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/HomePageReviews`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/HomePageReviews`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.BenefitsSection:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/BenefitsSection`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/BenefitsSection`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.BundleBanner:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/BundleBanner`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/BundleBanner`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.BundleContent:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/BundleContent`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/BundleContent`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.FollowUs:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/FollowUs`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/FollowUs`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.RecentlyView:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/RecentlyView`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/RecentlyView`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.BlogList:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/BlogList`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/BlogList`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.BlogDetail:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/BlogDetail`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/BlogDetail`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.RelatedBlogs:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/RelatedBlogs`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/RelatedBlogs`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.Reviews:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/Reviews`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/Reviews`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.ProductDetailSimilar:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/ProductDetailSimilar`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/ProductDetailSimilar`).then(
                (mod) => mod,
              );
            }),
        {
          ...options,
        },
      );
    case SectionsKey.CMSPage:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/CMSPage`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/CMSPage`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.ProductDetailSimilar:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/ProductDetailSimilar`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/ProductDetailSimilar`).then(
                (mod) => mod,
              );
            }),
        {
          ...options,
        },
      );
    case SectionsKey.SimilarProduct:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/SimilarProduct`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/SimilarProduct`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.AboutUs:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/AboutUs`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/AboutUs`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.Affiliate:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/Affiliate`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/Affiliate`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.Related + "_Top":
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/RelatedTop`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/RelatedTop`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.CategoriesSection:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/CategoriesSection`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/CategoriesSection`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.BenefitsSection:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/BenefitsSection`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/BenefitsSection`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );
    case SectionsKey.Introduction:
      return dynamic(
        () =>
          import(`~/theme/${getTheme()}/sections/Introduction`)
            .then((mod) => mod)
            .catch((error) => {
              return import(`~/sections/Introduction`).then((mod) => mod);
            }),
        {
          ...options,
        },
      );

    default:
      return null;
  }
};

export const renderSectionByKey = (
  key: string,
  dynamicProps?: DynamicOptions<any>,
) => {
  const ComponentToRender = componentMap[key];
  if (ComponentToRender) {
    return ComponentToRender;
  } else
    return dynamic(
      () =>
        import(`~/theme/${getTheme()}/sections/${key}`)
          .then((mod) => mod.default)
          .catch((error) => {
            return import(`~/sections/${key}`).then((mod) => mod.default);
          }),
      {
        ssr: false,
        loading: () => null,
        ...dynamicProps,
      },
    );
};
